import axios from "axios";
import { Constants } from "@CONFIG";
import { notification, message, Modal } from "antd";
import get from "lodash/get";

const Fetcher = async ({
  url,
  method,
  data = null,
  headers,
  errorMessage,
  successMessage,
  redirectIfFailed,
  redirectIfSuccess,
  dataKey,
  hideErrorMessageFromServer,
  errorMessageModal,
  hideSuccessMessage,
  responseType,
}) => {
  try {
    const token =
      localStorage.getItem(Constants.LOCAL_STORAGE_AUTH_KEY) ||
      localStorage.getItem(Constants.LOCAL_STORAGE_PRE_AUTH_KEY);
    const response = await axios({
      url,
      method,
      data,
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
      responseType,
    });
    if (responseType === "blob") {
      return response;
    }
    if (dataKey) {
      return get(response, dataKey);
    }

    if (response.data.message || successMessage) {
      if (!hideSuccessMessage) {
        message.success({
          content: response.data.message || successMessage,
          className: "app-success-message",
        });
      }

      return response.data;
    }

    return response.data.data || response.data || [];
  } catch (error) {
    if (
      error.response?.data instanceof Blob &&
      error.response?.data?.type === "application/json"
    ) {
      try {
        // Blob'u metne, metni de JSON objesine çevirip error.response.data'yı eziyoruz
        const text = await error.response.data.text();
        error.response.data = JSON.parse(text);
      } catch (e) {
        console.error("Blob hata mesajı dönüştürülemedi:", e);
      }
    }
    if (error.response?.data?.errors?.length > 0) {
      console.log(error.response.data.errors);
      Modal.error({
        title: "HATA !!",
        className: "big-modal",
        width: 800,
        okText: "Kapat",
        maskStyle: {
          backgroundColor: "rgb(243 5 5 / 90%)",
        },
        content: (
          <div>
            {error.response.data.errors.map((item, index) => {
              return <div key={`k-${index}`}>{item.msg}</div>;
            })}
          </div>
        ),
      });
      return error;
    }
    if (errorMessageModal) {
      Modal.error({
        title: "HATA !!",
        className: "big-modal",
        content: error.response?.data?.message,
        width: 800,
        okText: "Kapat",
        maskStyle: {
          backgroundColor: "rgb(243 5 5 / 90%)",
        },
      });

      /*
      setTimeout(() => {
        errorModal.destroy();
      }, 1500);
      */

      return false;
    }

    // apiden 401 dönerse ve api url'i içerisinde auth yoksa (auth/getTokenV2) redirect et.
    if (error.response?.status === 401) {
      localStorage.removeItem(Constants.LOCAL_STORAGE_AUTH_KEY);
      localStorage.removeItem(Constants.LOCAL_STORAGE_PRE_AUTH_KEY);
      const preAuthTypes = [
        "sendVerifyType",
        "setVerifyType",
        "sendOtp",
        "reSendOtp",
      ];
      const isPreAuth = preAuthTypes.some((type) => url.includes(type));

      if (isPreAuth) {
        setTimeout(() => {
          window.location.reload(); // 👈 2 saniye sonra refresh
        }, 2000);
        return;
      } else if (!window.location.pathname.startsWith("/auth/login")) {
        window.location.href = "/auth/login";
      }
    }

    if (error.response?.data?.message && !hideErrorMessageFromServer) {
      message.error({
        content: error.response?.data?.message,
        className: "app-error-message",
      });
      /*
      notification.error({
        message: 'Hata!',
        description: error.response?.data?.message,
      });
      */
    } else if (error.message === "Network Error") {
      Modal.error({
        title: "HATA !!",
        className: "big-modal",
        content:
          "Bağlantı Sorunu. Lütfen internet bağlantınızı kontrol ediniz.",
        width: 800,
        okText: "Tekrar Dene",
        onOk: () => {
          window.location.reload();
        },
        maskStyle: {
          backgroundColor: "rgb(243 5 5 / 75%)",
        },
      });
      return false;
    } else if (errorMessage) {
      notification.error({
        message: "Hata!",
        description: errorMessage,
      });
    }

    if (typeof redirectIfFailed === "function") {
      redirectIfFailed();
    }

    if (typeof redirectIfSuccess === "function") {
      redirectIfSuccess();
    }

    return error;
  }
};

export default Fetcher;
